
import React from 'react'

import { IGeneralData } from '@np/np_webcomponentlib'

import { optionEnum } from '../../shared/entityOperations/EntityFormTypes'

import { Column, ListFields } from '@np/np_webcomponentlib'

import { EntityFormProps } from '../../shared/entityOperations/EntityFormTypes'

import { ColumnWithCopyToClipboard } from '../../shared/entityOperations/EntityOperationsCustomFC'




export interface EntityType {
  [key: string]: string | number | Date | boolean | null | undefined ; // Допускаем, что значения могут быть строками или числами
  
  name: string;
  surname: string;
  patronicname: string;
  phoneNumber: string;
}


export interface DataEntityType extends IGeneralData, EntityType {
  login: string;
  needChangePassword: boolean;
}



//Расширенные данные для передачи сущности с предустановленными значениями для создания
export interface EntityFormPropsWithType extends EntityFormProps {
  initEntityProps: EntityType | undefined
}

// export const getEntityBylistVals = (listFields: ListFields[], entity: EntityType): EntityType => {
//   // Создаем новый объект на основе initEntity, чтобы не изменять оригинал
//   const updatedEntity: EntityType = { ...entity };

//   listFields.forEach(field => {
//     // Проверяем, существует ли такое поле в initEntity
//     if (field.fieldName in updatedEntity) {
//       // Устанавливаем первое значение из listVal, если оно существует
//       const valueToSet = field.listVal.length > 0 ? field.listVal[0] : '';
//       updatedEntity[field.fieldName] = valueToSet;
//     }
//   });

//   return updatedEntity;
// }


export const initEntity: EntityType = {
  name: "",
  surname: "",
  patronicname: "",
  phoneNumber: ""
}


export const columnsForChoose: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },

  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 5,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]



